define('tdcrossselling', ['jquery', 'wamodal'], function ($, wamodal) {

    return {
        iframe: '<iframe src="__SRC__?frame=1" id="csf"/>',
        crossSellingProduct: $('.accessories[data-frameurl]'),
        crosssellingFrameContainer: $('#crosssellingFrameContainer'),

        bindEvents: function bindEvents() {
            var _this = this;

            this.crossSellingProduct.on('click', function (e) {
                return wamodal.open(_this.iframe.replace('__SRC__', $(e.currentTarget).data('frameurl')));
            });
        },
        init: function init() {
            this.bindEvents();
        }
    };
});

